export const toSnakeCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1_$2") // Insert underscore before capital letters
    .replace(/[\s-]+/g, "_") // Replace spaces and hyphens with underscores
    .toLowerCase() // Convert to lowercase
    .replace(/_{2,}/g, "_") // Replace multiple underscores with single underscore
    .replace(/^_|_$/g, ""); // Remove leading/trailing underscores
};
